/**
 * Single source of truth for the GA4 hostname gate (FRIDGE-72).
 *
 * The pattern matches the apex domain (`fridge.com`) and every subdomain
 * (`www.fridge.com`, `data.fridge.com`) while rejecting lookalike suffixes
 * (`notfridge.com`, `fridge.com.evil.example`), localhost, and Vercel
 * preview hosts (`*-git-*.vercel.app`).
 *
 * `app/google-analytics.tsx` interpolates TRACKED_HOST_REGEX_SOURCE into its
 * inline gtag snippet, so the browser-side gate and this unit-testable
 * function are literally the same pattern and cannot drift. The live site
 * serves the apex (`www.fridge.com` 301s to `fridge.com`), so the apex case
 * is the one production depends on — verified against the deployed chunk and
 * live GA4 stream data on 07/25/2026.
 */
export const TRACKED_HOST_REGEX_SOURCE = String.raw`(^|\.)fridge\.com$`

export function isTrackedAnalyticsHost(hostname: string): boolean {
  return new RegExp(TRACKED_HOST_REGEX_SOURCE).test(hostname)
}
